import { Theme } from 'boss-ui';
export default Theme;